import { Component } from '@angular/core';
import {GeneralExerciseComponent} from '../../General/g-exercise.component';
import {ActivatedRoute} from '@angular/router';
import {TopicService} from '../topic.service';
import {MessageService} from '../../shared/message.service';

@Component({
  selector: 'app-bubble-sort',
  templateUrl: './bubble-sort.component.html',
  styleUrls: ['./bubble-sort.component.css']
})
export class BubbleSortComponent extends GeneralExerciseComponent {

  level = 1;
  counter = 0;
  cards: number[];
  isCovered: boolean;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
    this.printable = true;
  }

  initValues() {
    this.setTypeSpecificsFromConfiguration();
    this.solved = false;
    this.cards = [];
  }

  checkSolution() {
    if (this.checkIsSorted()) {
      this.messageService.addAlertWithTimeout(this.get('correctlyDecoded'), 'success', 1000);
      this.solved = true;
      this.isSolvedImageVisible = true;
      this.isCovered = false;
      setTimeout(() => { this.isSolvedImageVisible = false; }, 800);
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get('notCorrectlyDecoded'), 'danger', 2000);
      // const audio = document.getElementsByTagName('audio')[0];
      // audio.play();
    }
  }

  generateNextExercise() {
    this.counter ++;
    this.initValues();
  }

  setLevel(level: number) {
    this.level = level;
  }

  computeState() {
    this.state.counter = this.counter;
  }

  setTypeSpecificsFromConfiguration() {
    this.isCovered = this.configuration.typespecifics.covered;
  }

  setTypeSpecificsFromState() {
    if (this.state) {
      if (this.state.counter) {
        this.counter = this.state.counter;
      }
    }
  }

  checkIsSorted() {
    const numberOfCards = this.cards.length;
    let lastCard = this.cards[0];
    for (let i = 1; i < numberOfCards; i++) {
      if (lastCard < this.cards[i]) {
        lastCard = this.cards[i];
      } else {
        return false;
      }
    }
    return true;
  }

  setSolution(cardIds) {
    this.cards = cardIds;
  }

}
